export const getConfiguredDeviceList = /* GraphQL */ `
  query getConfiguredDevice($tenantCode: String!) {
    getConfiguredDevice(tenantCode: $tenantCode) {
      fcl
      flr
      loc
      stm
      uni
      pk
      created_at
      updated_at
    }
  }
`;

export const getLocationListQuery = /* GraphQL */ `
  query getLocations($tenantCode: String!, $username: String!, $is_deleted: Boolean) {
    getLocations(tenantCode: $tenantCode, username: $username, is_deleted: $is_deleted) {
      key
      parentKey
      name
      type
      short_code
      created_at
      updated_at
      is_deleted
      is_region
      is_unit
      unit_key
      space_id
      facility_unit_key
      locationName
      floor_key
    }
  }
`;

export const getAllRollListQuery = /* GraphQL */ `
  query getAllRoles($is_deleted: Boolean, $tenantCode: String) {
    getAllRoles(is_deleted: $is_deleted, tenantCode: $tenantCode) {
      pk
      sk
      role_name
      role_code
      ux_index
      permission_pages
      is_deleted
      created_at
      updated_at
    }
  }
`;

export const getRolePermissionQuery = /* GraphQL */ `
  query MyQuery {
    getRolePermission {
      label
      menuId
      menukey
      userRoles
      child {
        label
        menukey
        userRoles
      }
    }
  }
`;

export const getTenantsQuery = /* GraphQL */ `
  query getTenants($search: String, $key: String, $limit: String!, $pageNo: String!, $is_deleted: Boolean!) {
    getTenants(search: $search, key: $key, limit: $limit, pageNo: $pageNo, is_deleted: $is_deleted) {
      tenants {
        description
        email
        image
        isActive
        lastLogin
        tenant_name
        phone
        industry
        tenantId
        tenantCode
        userName
        middle_name
        is_deleted
        created_at
        updated_at
        email_message
        notification
        message
        public_sso
        enterprise_sso
        force_mfa
        enable_mfa
        userStatus
      }
      count
    }
  }
`;

export const getTenantsDropDownQuery = /* GraphQL */ `
  query getTenants($all: String) {
    getTenants(all: $all) {
      tenants {
        tenantCode
        tenant_name
        tenantId
      }
    }
  }
`;

export const getTenantUsersQuery = /* GraphQL */ `
  query getTenantUsers($tenantId: String!, $is_deleted: Boolean) {
    getTenantUsers(tenantId: $tenantId, is_deleted: $is_deleted) {
      email
      group
      enabled
      userStatus
      name
      middle_name
      tenantId
      userName
      phone
      lastLogin
      created_at
      modified_at
      userFacility
      email_message
      notification
      message
      enable_mfa
      force_mfa
    }
  }
`;
export const getTenantUsersForEmailQuery = /* GraphQL */ `
  query getTenantUsers($tenantId: String!, $is_deleted: Boolean) {
    getTenantUsers(tenantId: $tenantId, is_deleted: $is_deleted) {
      email
      name
      middle_name
    }
  }
`;
export const getAdminQuery = /* GraphQL */ `
  query getAdmin($is_deleted: Boolean) {
    getAdmin(is_deleted: $is_deleted) {
      email
      group
      enabled
      name
      userName
      phone
      lastLogin
      created_at
      modified_at
    }
  }
`;

export const getCalibrationQuery = /* GraphQL */ `
  query getCalibration {
    getCalibration {
      bio_A
      bio_B
      bio_C
      bio_D
      deviceCode
      key
      pk
      sk
      tpm_A
      tpm_B
      tpm_C
      tpm_D
    }
  }
`;

export const getEventListQuery = /* GraphQL */ `
  query getEventMap($tenantCode: String!) {
    getEventMap(tenantCode: $tenantCode) {
      pk
      sk
      ward_id
      system_id
      facility_id
      image_data
      image_map_data
      created_at
      updated_at
    }
  }
`;

export const GetSubStanceList = /* GraphQL */ `
  query getSettings {
    getSettings {
      substances {
        group
        order
        substance
        substanceKey
        unit
      }
      severityLevels {
        color
        index
        order
      }
    }
  }
`;
export const GetAggMeasurements = /* GraphQL */ `
  query getAggMeasurements($params: InputRequest!) {
    getAggMeasurements(params: $params) {
      location
      order
      worstSubstanceKey
      elapsedTimes {
        index
        color
        et
      }
      lastUpdateTime
      readings {
        substance
        substanceKey
        group
        value
        value1
        unit
        index
        order
        color
        count
        epochSince
        isoIndex
      }
      notifications {
        value
      }
    }
  }
`;

export const getDetailMeasurements = /* GraphQL */ `
  query getDetailMeasurements($params: InputRequest!) {
    getDetailMeasurements(params: $params) {
      location
      worstSubstanceKey
      lastUpdateTime
      order
      worstSubstanceKey
      elapsedTimes {
        color
        et
        index
      }
      lastUpdateTime
      readings {
        deviceId
        count
        index
        order
        substance
        substanceKey
        trend
        unit
        value
        value1
        color
        epochSince
        group
        isoIndex
      }
      notifications {
        value
      }
    }
  }
`;
export const getSubstanceDetail = /* GraphQL */ `
  query getSubstanceDetails($params: QueryRequest!) {
    getSubstanceDetails(params: $params) {
      elapsedTimes {
        color
        et
        index
      }
      measures {
        color
        index
        time
        value
      }
    }
  }
`;
export const unLinkRoom = /* GraphQL */ `
  query unconfigDevices($deviceIds: [String]!, $tenantCode: String!) {
    unconfigDevices(deviceIds: $deviceIds, tenantCode: $tenantCode) {
      success
    }
  }
`;
export const getCalibrationNewListQuery = /* GraphQL */ `
  query getCalibrationList($tenantCode: String!) {
    getCalibrationList(tenantCode: $tenantCode) {
      bio {
        A
        B
        C
        D
        sk
        pk
        updated_at
      }
      tpm {
        A
        B
        C
        D
        sk
        pk
        updated_at
      }
      pm {
        A
        B
        C
        D
        sk
        pk
        updated_at
      }
      sensitivity_eczero {
        A
        B
        sk
        pk
        updated_at
      }
      bioi {
        A
        B
        sk
        pk
        updated_at
      }
      equationData {
        a
        b
        n
        l
        lo
        r
        sk
        pk
        updated_at
      }
      ledData {
        A
        sk
        pk
        updated_at
      }
      gases {
        A
        B
        C
        D
        unit
        optiontype
        current_active
        active_option
        sk
        pk
        updated_at
      }
      piera {
        A
        B
        C
        D
        optiontype
        current_active
        active_option
        sk
        pk
        updated_at
      }
      biochamber {
        A
        B
        C
        D
        optiontype
        current_active
        active_option
        sk
        pk
        updated_at
      }
      apsData {
        A
        sk
        pk
        updated_at
      }
      isoLevelsData {
        A
        B
        C
        D
        E
        F
        G
        index
        sk
        pk
        updated_at
      }
      biosummarypc {
        A
        B
        C
        D
        optiontype
        current_active
        active_option
        sk
        pk
        updated_at
      }
      biosummary {
        sk
        pk
      }
    }
  }
`;

export const fetchGrafanaQuery = `query getGrafana($tenantCode: String! , $tenantId: String!) {
    getGrafana(tenantCode: $tenantCode, tenantId: $tenantId) {
        pk
        sk
        username
        tenant_code
        grafana_data
        created_at
        updated_at
    }
}`;

export const getUserGrafanaDashboardQuery = `query getUserGrafanaDashboard($pk: String, $username: String!, $tenantCode: String!) {
  getUserGrafanaDashboard(pk: $pk, username: $username, tenantCode: $tenantCode) {
    pk
    sk
    username
    dashboard_name
    grafana_data
    tenant_code
    created_at
    updated_at
  }
}`;

export const getCategoryListQuery = /* GraphQL */ `
  query getCategory($tenantCode: String!) {
    getCategory(tenantCode: $tenantCode) {
      pk
      sk
      category_name
      order_number
      created_at
      updated_at
    }
  }
`;

export const getConfiguredDeviceListNew = /* GraphQL */ `
  query getConfiguredDeviceNew($tenantCode: String!) {
    getConfiguredDeviceNew(tenantCode: $tenantCode) {
      fcl
      flr
      loc
      stm
      uni
      pk
      sk
      location_name
      tenantCode
      created_at
      updated_at
      deviceImage
      deviceImageUrl
      providerId
      provider
    }
  }
`;
export const getDashboardQueryDetailsWithInterval =
  /* GraphQL */
  `
    query getDashboardQueryDetails($fromDate: String!, $level: String!, $location: String!, $substanceKeys: [String]!, $toDate: String!, $deviceKeys: [String]!, $sensorIds: [String]!, $interval: String) {
      getDashboardQueryDetails(params: { fromDate: $fromDate, level: $level, location: $location, substanceKeys: $substanceKeys, toDate: $toDate, deviceKeys: $deviceKeys, sensorIds: $sensorIds, interval: $interval }) {
        records {
          deviceId
          reading
          reading1
          time
          substanceKey
        }
      }
    }
  `;

export const getDashboardQueryDetails =
  /* GraphQL */
  `
    query getDashboardQueryDetails($fromDate: String!, $level: String!, $location: String!, $substanceKeys: [String]!, $toDate: String!, $deviceKeys: [String]!, $sensorIds: [String]!) {
      getDashboardQueryDetails(params: { fromDate: $fromDate, level: $level, location: $location, substanceKeys: $substanceKeys, toDate: $toDate, deviceKeys: $deviceKeys, sensorIds: $sensorIds }) {
        records {
          deviceId
          reading
          reading1
          time
          substanceKey
        }
      }
    }
  `;

export const GetQueryDetails =
  /* GraphQL */
  `
    query GetQueryDetails($params: QueryParameters) {
      getQueryDetails(params: $params) {
        records {
          color
          index
          count
          location
          substance
          substanceKey
          time
        }
      }
    }
  `;

export const getSubstanceThresholds = /* GraphQL */ `
  query getSubstanceThresholds($params: ThresholdRequest) {
    getSubstanceThresholds(params: $params) {
      thresholds {
        ranges {
          delay
          expression
          index
          upper
          lower
          type
        }
        standard
        description
        substanceKey
      }
    }
  }
`;

export const getSubstanceConfig = /* GraphQL */ `
  query getSubstanceConfiguration($tenantCode: String!, $isDelete: Boolean) {
    getSubstanceConfiguration(tenantCode: $tenantCode, isDelete: $isDelete) {
      order_no
      pk
      sk
      substanceKey
      displayName
      group
      unit
      is_delete
      category_id
      providers
    }
  }
`;

export const getDevopsDashbordQuery = /* GraphQL */ `
  query getDevopsDashbord {
    getDevopsDashbord {
      total_sale
      locations {
        floor
        rooms
        system
        unit
        facility
      }
      configured_device {
        fcl
        flr
        loc
        location_name
        pk
        sk
        stm
        uni
      }
      total_tenant {
        last_month_tenant
        total_active_tenant
        total_freez_tenant
        total_inactive_tenant
        total_tenant
        total_mobile_users
        total_active_devices
        total_active_users
        total_disabled_users
      }
      notifications
      customer {
        disabled
        enabled
        total_customer
      }
      online_devices
      offline_devices
    }
  }
`;

export const getThresholdNotificationQuery =
  /* GraphQL */
  `
    query getThresholdNotification($tenantCode: String!) {
      getThresholdNotification(tenantCode: $tenantCode) {
        colorIndex
        pk
        sk
        status
        substance
        substanceKey
      }
    }
  `;

export const getThresholdNotificationChanelquery = /*GraphQL*/ `query getThresholdNotificationChanel($tenantCode:String!) {
  getThresholdNotificationChanel(tenantCode: $tenantCode) {
    email
    pk
    push
    sk
    sms
  }
}`;

export const getUserNotificationsQuery =
  /*GraphQL*/
  `query getUserNotifications($pageNo:Int! $userName:String! $LastEvaluatedPk:String $LastEvaluatedSk:String ) {
  getUserNotifications(pageNo: $pageNo, userName: $userName,LastEvaluatedPk:$LastEvaluatedPk, LastEvaluatedSk : $LastEvaluatedSk) {
    count
    notifications {
      actualEpoch
      sentTime
      deviceId
      is_read
      location
      message
      text
      status
      substance
      locationKey
      facilityKey
      pk
      sk
      index
    }
    totalPage
    unread
    read
    LastEvaluatedPk
    LastEvaluatedSk
  }
}`;

export const getUserNotificationsWithReadUnreadQuery =
  /*GraphQL*/
  `query getUserNotificationsWithReadUnread($pageNo:Int! $status:String $userName:String! $LastEvaluatedPk:String $LastEvaluatedSk:String ) {
    getUserNotificationsWithReadUnread(pageNo: $pageNo, status: $status, userName: $userName,LastEvaluatedPk:$LastEvaluatedPk, LastEvaluatedSk : $LastEvaluatedSk) {
      count
      read
      totalPage
      unread
      notificationsAll {
        LastEvaluatedPk
        LastEvaluatedSk
        notifications {
          actualEpoch
          deviceId
          facilityKey
          index
          location
          is_read
          locationKey
          message
          pk
          sentTime
          sk
          status
          text
          substance
        }
      }
      notificationsRead {
        LastEvaluatedPk
        LastEvaluatedSk
        notifications {
          actualEpoch
          deviceId
          facilityKey
          index
          is_read
          location
          locationKey
          message
          pk
          sentTime
          sk
          status
          substance
          text
        }
      }
      notificationsUnRead {
        LastEvaluatedPk
        LastEvaluatedSk
        notifications {
          text
          substance
          status
          sk
          pk
          message
          locationKey
          location
          is_read
          index
          facilityKey
          deviceId
          actualEpoch
          sentTime
        }
      }
  }
}`;

export const getInternalIdsQuery = `
query getAllInternalDeviceIds($tenantCode:String) {
  getAllInternalDeviceIds(tenantCode:$tenantCode) {
    internalIds {
      pk
      sk
      is_deleted
      internalId
      created_at
      updated_at
    }
    configured_device {
      fcl
      flr
      loc
      location_name
      pk
      sk
      stm
      uni
    }
  }
}`;

export const getDownloadDashboardQuery = /* GraphQL */ `
  query getDownloadQueryDetails($params: DashboardQueryParameters!) {
    getDownloadQueryDetails(params: $params) {
      path
    }
  }
`;
export const getEmailTemplatesQuery = /* GraphQL */ `
  query listEmailTemplate($nextToken: String) {
    listEmailTemplate(nextToken: $nextToken) {
      TemplateName
      TextPart
      SubjectPart
      HtmlPart
      CreatedTimestamp
    }
  }
`;
export const getSendEmailhistoryQuery = /* GraphQL */ `
  query getSendSESEmailHistory($tenantCode: String, $LastEvaluatedPk: String, $LastEvaluatedSk: String) {
    getSendSESEmailHistory(tenantCode: $tenantCode, LastEvaluatedPk: $LastEvaluatedPk, LastEvaluatedSk: $LastEvaluatedSk) {
      pk
      sk
      ToAddresses
      HtmlPart
      SubjectPart
    }
  }
`;

export const GetRelatedSubstances = /* GraphQL */ `
  query getRelatedSubstances($params: RelatedSubstanceRequest) {
    getRelatedSubstances(params: $params) {
      substances {
        location
        substanceKey
        value
        index
        value1
      }
    }
  }
`;
export const getDeviceHistoryQuery = /* GraphQL */ `
  query getdeviceHistorylist($pageNo: Int!, $rowsPerPage: Int!, $searchText: String!) {
    getdeviceHistorylist(pageNo: $pageNo, rowsPerPage: $rowsPerPage, searchText: $searchText) {
      LastEvaluatedPk
      LastEvaluatedSk
      count
      totalPage
      deviceHistory {
        deviceId
        internalId
        device_location
        device_name
        device_status
        discription
        firmware_device
        installation_date
        lat
        location
        long
        manufacturer_device
        pk
        sk
        tenant_assignment
        type
        updated_date
      }
    }
  }
`;
export const getAllDevicesData = `
query  getAllDevices {
  getAllDevices {
    id
    type
    attributes {
      name
      version
      agent_id
      agent_url
      device_online
      device_state_changed_at
      agent_running
      agent_state_changed_at
      last_enrolled_at
      imp_type
      ip_address
      iccid
      tags
      mac_address
    }
    relationships {
      devicegroup {
        type
        id
      }
    }
  }
}
`;

export const getConfigutedDeviceWithLocationQuery = `
query MyQuery {
  getConfigutedDeviceWithLocation {
    location
    deviceid
    system
  }
}`;

export const getDeviceWithWorstSubstanceQuery = `
query getDevicesWithWorstSubstances($params: DeviceWithWorstIndexRequest) {
  getDevicesWithWorstSubstances(params: $params) {
    devices {
      deviceId
      pDeviceId
      worstIndex
    }
  }
}`;

export const getTenantReportQuery = `
query getTenantReport($tenants:[getTenantReportRequest!]) {
    getTenantReport(tenants: $tenants) {
      tenantId
      info {
       system
        facility
        floor
        unit
        rooms
        assingDevices
        users
        ssoUsers
        loginUser
      }
    }
  }
`;
export const getDeviceAllVersionQuery = /* GraphQL */ `
  query MyQuery {
    getAllDeviceVersion {
      pk
      version_name
      devices
      created_at
      updated_at
    }
  }
`;
export const deleteDeviceVersionQuery = /* GraphQL */ `
  query deleteDeviceVersion($version: deleteVersionRequest!) {
    deleteDeviceVersion(version: $version) {
      message
      success
    }
  }
`;

export const getFacilityDeviceLocationsQuery = /* GraphQL */ `
  query getFacilityDeviceLocationsQ($facilityDeviceLocation: facilityDeviceLocationType) {
    getFacilityDeviceLocationsQ(facilityDeviceLocation: $facilityDeviceLocation) {
      data
      success
      message
    }
  }
`;
export const getNotificationRulesQuery = /* GraphQL */ `
  query getNotificationRules($tenantId:String, $facilityKey:String) {
    getNotificationRules(tenantId: $tenantId, facilityKey:$facilityKey) {
      notification_data {
        pk
        sk
        yellow_delay
        yellow_text
        red_delay
        red_text
        black_delay
        black_text
      }
      default_notification {
      pk
      sk
      yellow_delay
      yellow_text
      red_delay
      red_text
      black_delay
      black_text
    }
    }
  }
`;
export const getDashboardOrderData = /* GraphQL */`
  query getDashboardOrderData($getDashboardWidgetRequest: getDashboardWidgetsRequest){
    getDashboardOrderData(getDashboardWidgetRequest:$getDashboardWidgetRequest){
      result
    }
  }
`;

export const getRecentNotifications =/* GraphQL */`
  query getRecentNotificationList($recentNotificationRequest: getRecentNotificationRequest){
    getRecentNotificationList(recentNotificationRequest:$recentNotificationRequest){
      pk
      sk
      actualEpoch
      colorCode
      deviceId
      facilityKey
      index
      is_archive
      is_read
      location
      locationKey
      message
      sentTime
      sen_id
      status
      substance
      tenantId
      text
      ua
      value
    }
  }
`
export const getDailyChartAlertQuery =/* GraphQL */`
  query getDailyChartAlertData($dailyAlertRequest: getDailyAlertRequest){
    getDailyChartAlertData(dailyAlertRequest: $dailyAlertRequest){
      pk
      sk
      entryTime
      index
      ua
    }
  }
`
export const getEnvironmentRiskScore =/* GraphQL */`
 query getRiskScoreData($riskScoreRequest: getRiskScoreRequest) {
    getRiskScoreData(riskScoreRequest: $riskScoreRequest){
      riskScore 
      entryScores {
        timestamp
        score
        change
        index
      }        
    }
  }
`
export const getStackRankingData =/* GraphQL */`
  query getStackRanking($stackRankingRequest: getStackRankingRequest){
    getStackRanking(stackRankingRequest: $stackRankingRequest){
      count 
      index2
      index3
      index4
      index5
      pk
    }
  }
`
export const getSubstanceFrequencyData =/* GraphQL */`
  query getSubstanceFrequency($substanceFrequencyRequest: getSubstanceFrequencyRequest){
    getSubstanceFrequency(substanceFrequencyRequest: $substanceFrequencyRequest){
      pk
      total_diff_duration
      index
    }
  }
`;

export const getSingleSubstanceFrequencyQuery =/* GraphQL */`
query getSubstanceFrequencyWithSubstance($singleSubstanceFrequencyRequest: getSingleSubstanceFrequencyRequest) {
  getSubstanceFrequencyWithSubstance(singleSubstanceFrequencyRequest: $singleSubstanceFrequencyRequest){
    black
    device_loc
    red
    yellow
  }
}`;

export const deleteCategoryQuery = /* GraphQL */ `
  query deleteCategory($categorytDelete: categoryDeleteRequest!) {
    deleteCategory(categorytDelete: $categorytDelete) {
      message
      success
    }
  }
`;

export const getDeviceProviderConfigurationListQuery = /* GraphQL */ `
  query getDeviceProviderConfigurationList($tenantCode:String!)  {
    getDeviceProviderConfigurationList(tenantCode:$tenantCode) {
      created_at
      data
      name
      pk
      provider
      sk
      updated_at
    }
  }
`;

export const getThirdPartyDevicesQuery = /* GraphQL */ `
  query getThirdPartyDevices($providerId: String!) {
    getThirdPartyDevices(providerId: $providerId) {
      created_at
      deviceId
      pk
      sk
      updated_at
      deviceName
      location
      configured
    }
  }
`;

export const getVerkadaDeviceDataQuery = /* GraphQL */ `
  query getVerkadaDeviceData($getDeviceData:thirdPartyDeviceDataRequest!) {
    getVerkadaDeviceData(getDeviceData: $getDeviceData) {
      device_id
      device_name
      device_serial
      interval
      next_page_token
      readings {
        temperature
        tamper
        pm_4_0
        pm_2_5
        pm_1_0_0
        noise_level
        motion
        humidity
        heat_index
        ambient_light
        barometric_pressure
        carbon_dioxide
        carbon_monoxide
        formaldehyde
        vape_index
        usa_air_quality_index
        tvoc_index
        time
      }
    }
  }
`;

export const getDeviceProviderConfigurationListMutation = /* GraphQL */ `
  query getDeviceProviderConfigurationList{
    getDeviceProviderConfigurationList{
      pk
      sk
      providerId
      data
      created_at
      updated_at
    }
  }
`;

export const getProviderListQuery = /* GraphQL */ `
  query getProviderList($tenantCode:String!){
    getProviderList(tenantCode: $tenantCode) {
      json_data
      pk
      providerId
      provider_name
      sk
      tenantCode
    }
  }
`;
